import { getUtmParameters } from 'util/utm'
import { UtmParameters } from 'util/utm/utm-types'
import { removeEmptyObjects } from 'util/removeEmptyObjects'

export type IncommUtmPayload = Partial<{
  utmSource: string | null
  utmMedium: string | null
  utmCampaign: string | null
  utmTerm: string | null
  utmContent: string | null
  originalUtmSource: string | null
  originalUtmMedium: string | null
  originalUtmCampaign: string | null
  originalUtmTerm: string | null
  originalUtmContent: string | null
}>

const normalizeUtmValue = (value?: string | null): string | null => {
  const trimmed = value?.trim()
  return trimmed ? trimmed : null
}

const mapUtmParametersToPayload = (
  parameters?: UtmParameters | null,
): IncommUtmPayload => ({
  utmSource: normalizeUtmValue(parameters?.utm_source),
  utmMedium: normalizeUtmValue(parameters?.utm_medium),
  utmCampaign: normalizeUtmValue(parameters?.utm_campaign),
  utmTerm: normalizeUtmValue(parameters?.utm_term),
  utmContent: normalizeUtmValue(parameters?.utm_content),
  originalUtmSource: normalizeUtmValue(parameters?.utm_source),
  originalUtmMedium: normalizeUtmValue(parameters?.utm_medium),
  originalUtmCampaign: normalizeUtmValue(parameters?.utm_campaign),
  originalUtmTerm: normalizeUtmValue(parameters?.utm_term),
  originalUtmContent: normalizeUtmValue(parameters?.utm_content),
})

export const getIncommUtmPayload = async (): Promise<IncommUtmPayload> => {
  try {
    const utmData = await getUtmParameters()
    const parameters = utmData?.parameters

    if (!parameters) {
      return {}
    }

    return removeEmptyObjects(mapUtmParametersToPayload(parameters))
  } catch (error) {
    console.error('Error building Incomm UTM payload', error)
    return {}
  }
}
